import { useLocation } from 'react-router';
import { RouteStates, RouteState } from 'Router/types';

export function useTypedLocation<T extends keyof RouteStates>() {
  const location = useLocation();

  return {
    ...location,
    state: location.state as RouteState<T> | null,
  };
}
